import React, { useState, useEffect, useRef } from 'react';
import './../../App.css';
import './Employees.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { CreateButton } from './../CommonObjects';
import { SetAuditTrail } from './../Reports/AuditTrailReportEmployeeSetup';
import axios from '../../api/apiClient';
import { token, domain, ALLOW_LEAVE_CREDITS_MODULE } from './../Security';
import {
  HR7_IS_CLOUD,
  getUnliAccount
} from './../Security';
import { checkLicenseIfTaken, fetchLicenseDetails, insertUserSubscription, removeUserSubscription } from '../../api/subscriptionApi';
import { fileToBase64Old as fileToBase64 } from "../../utils/fileUtils";
import { useRefetchTrigger } from '../../hooks/useRefetchTrigger';

// tabs
import { PersonalTab } from './ViewEmployeeFld/tabs/PersonalTab';
import { AddressTab } from './ViewEmployeeFld/tabs/AddressTab';
import { AddressTabWithAPI } from './ViewEmployeeFld/tabs/AddressTabWithAPI';
import { BenefitsTab } from './ViewEmployeeFld/tabs/BenefitsTab';
import { DependentsTab } from './ViewEmployeeFld/tabs/DependentsTab';
import { AccountsTab } from './ViewEmployeeFld/tabs/AccountsTabFld/AccountsTab';
import { EmergencyTab } from './ViewEmployeeFld/tabs/EmergencyTab';
import { FamilyTab } from './ViewEmployeeFld/tabs/FamilyTab';
import { GenerateIdTab } from './ViewEmployeeFld/tabs/GenerateIdTab';
import { InformationTab } from './ViewEmployeeFld/tabs/InformationTab';
import { RequirementsTab } from './ViewEmployeeFld/tabs/RequirementsTab';
import { TrainingsAndSeminarsTab } from './ViewEmployeeFld/tabs/TrainingsAndSeminarsTab';
import { EducationsTab } from './ViewEmployeeFld/tabs/EducationsTab';
// icons
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import CloseIcon from '@mui/icons-material/Close';
import { LoadingSpinner } from '../../common/Loading';
import { GeneralMessage, useGeneralMessage } from '../../common/APICommon';
import { Next, Previous } from './ViewEmployeeFld/utils/page';
import { MemoTab } from './ViewEmployeeFld/tabs/MemoTab';
import { LeaveCreditsTab } from '../../v2/components/modules/Employee/tabs/LeaveCreditsTab';
import { FEATURES } from '../../config/features';
import { EmployeeSalaryTab } from './ViewEmployeeFld/tabs/EmployeeSalaryTab';
import { useEmployeeSalaryConfig } from '../../v2/hooks/useEmployeeSalaryConfig';

export function ViewEmployeeModal({
  user,
  isOpen,
  onClose,
  viewedData,
  setViewedData,
  fetchData,
  employeePhoto,
  setEmployeePhoto
}) {


  const leaveTabRef = useRef(); // use this to access the save function inside LeaveCreditsTab for deferred saving when the main save button is clicked in ViewEmployeeModal

  const { showMessage, message, isSuccess, showGeneralMessage } = useGeneralMessage();

  //#region UseEffects Props
  // console.log(viewedData)
  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedEducationTab, setSelectedEducationTab] = useState(0);
  const [isFirstPage, setIsFirstPage] = useState(true);
  const [isLastPage, setIsLastPage] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [isOpenOnce, setIsOpenOnce] = useState(false);

  //Personal
  const [employeePersonalInformationId, setEmployeePersonalInformationId] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [selectedFile, setSelectedFile] = useState("");
  const [lastName, setLastName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [extensionName, setExtensionName] = useState("");
  const [nickName, setNickName] = useState("");
  const [age, setAge] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [placeOfBirth, setPlaceOfBirth] = useState("");
  const [civilStatus, setCivilStatus] = useState("");
  const [bloodType, setBloodType] = useState("");
  const [height, setHeight] = useState("");
  const [weight, setWeight] = useState("");
  const [citizenship, setCitizenship] = useState("");
  const [religion, setReligion] = useState("");
  const [gender, setGender] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [deviceNumber, setDeviceNumber] = useState("");
  const [companyId, setCompanyId] = useState("");
  const [signature, setSignature] = useState([]);
  const [license, setLicense] = useState("");

  //Address
  const [province, setProvince] = useState("");
  const [region, setRegion] = useState("");
  const [blkLot, setBlkLot] = useState("");
  const [street, setStreet] = useState("");
  const [barangay, setBarangay] = useState("");
  const [city, setCity] = useState("");
  const [municipality, setMunicipality] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [yearsOfStay, setYearsOfStay] = useState("");
  //Information
  const [effectiveFrom, setEffectiveFrom] = useState("");
  const [contractFrom, setContractFrom] = useState("");
  const [contractTo, setContractTo] = useState("");
  const [locationId, setLocationId] = useState("");
  const [dateEmployed, setDateEmployed] = useState("");
  const [dateRegular, setDateRegular] = useState("");
  const [dateProbationary, setDateProbationary] = useState("");
  const [dateProjectBase, setDateProjectBase] = useState("");
  const [dateContractual, setDateContractual] = useState("");
  const [dateResigned, setDateResigned] = useState("");
  const [employmentId, setEmploymentId] = useState("");
  const [departmentId, setDepartmentId] = useState("");
  const [sectionId, setSectionId] = useState("");
  const [classificationId, setClassificationId] = useState("");
  const [payTypeId, setPayTypeId] = useState("");
  const [shiftScheduleId, setShiftScheduleId] = useState("");
  const [positionId, setPositionId] = useState("");
  const [salaryType, setSalaryType] = useState("");
  const [maintenanceSalaryCombinationV2Id, setmaintenanceSalaryCombinationV2Id] = useState("");
  const [sickLeave, setSickLeave] = useState("");
  const [vacationLeave, setVacationLeave] = useState("");
  const [serviceIncentiveLeave, setServiceIncentiveLeave] = useState("");
  const [soloParentLeave, setSoloParentLeave] = useState("");
  const [sickRemaining, setSickRemaining] = useState("");
  const [vacationRemaining, setVacationRemaining] = useState("");
  const [serviceIncentiveRemaining, setServiceIncentiveRemaining] = useState("");
  const [soloParentRemaining, setSoloParentRemaining] = useState("");
  const [employeeStatus, setEmployeeStatus] = useState("");
  const [jobTitleId, setJobTitleId] = useState("");
  const [employeeGroup1Id, setEmployeeGroup1Id] = useState("");
  const [employeeGroup2Id, setEmployeeGroup2Id] = useState("");
  const [plantilyaId, setPlantilyaId] = useState("");
  const [costCenterId, setCostCenterId] = useState("");
  const [clientId, setClientId] = useState("");
  const [employeeTypeId, setEmployeeTypeId] = useState("");
  const [vesselId, setVesselId] = useState("");
  const [destinationId, setDestinationId] = useState("");

  // --- Accounts ---
  // Accounts : Gov Premiums
  const [sss, setsss] = useState("");
  const [tin, setTin] = useState("");
  const [philhealth, setPhilhealth] = useState("");
  const [pagibig, setPagibig] = useState("");

  // Accounts : FOR PASSPORT & SEAMAN'S BOOK
  const [passport, setPassport] = useState("");
  const [passportIssueDate, setPassportIssueDate] = useState("");
  const [passportExpiryDate, setPassportExpiryDate] = useState("");
  const [seamansBookNumber, setSeamansBookNumber] = useState("");
  const [seamansBookIssueDate, setSeamansBookIssueDate] = useState("");
  const [seamansBookExpiryDate, setSeamansBookExpiryDate] = useState("");

  // Accounts : License Information
  const [licenseCode, setLicenseCode] = useState("");
  const [licenseDescription, setLicenseDescription] = useState("");
  const [licenseNumber, setLicenseNumber] = useState("");
  const [licenseQualified, setLicenseQualified] = useState(false);
  const [licenseExpirationDate, setLicenseExpirationDate] = useState("");

  // Accounts: Bank Information
  const [employeeBankAccounts, setEmployeeBankAccounts] = useState([]);


  // --- End Accounts ---

  //Education & Trainings
  const [employeeEducationAttainments, setEmployeeEducationAttainments] = useState([]);
  const [employeeTrainingSeminars, setEmployeeTrainingSeminars] = useState([]);
  //Dependents
  const [employeeDependents, setEmployeeDependents] = useState([]);
  //Emegency
  const [employeeEmergencyContacts, setEmployeeEmergencyContacts] = useState([]);
  //Family
  const [employeeFamilyData, setEmployeeFamilyData] = useState([]);
  //Restdays
  const [employeeRestDays, setEmployeeRestDays] = useState([]);

  //old values
  const [isInit, setIsInit] = useState(false);
  const [oldEmployeeId, setOldEmployeeId] = useState("");
  const [oldSelectedFile, setOldSelectedFile] = useState("");
  const [oldLastName, setOldLastName] = useState("");
  const [oldFirstName, setOldFirstName] = useState("");
  const [oldMiddleName, setOldMiddleName] = useState("");
  const [oldExtensionName, setOldExtensionName] = useState("");
  const [oldNickName, setOldNickName] = useState("");
  const [oldAge, setOldAge] = useState("");
  const [oldDateOfBirth, setOldDateOfBirth] = useState("");
  const [oldPlaceOfBirth, setOldPlaceOfBirth] = useState("");
  const [oldCivilStatus, setOldCivilStatus] = useState("");
  const [oldBloodType, setOldBloodType] = useState("");
  const [oldHeight, setOldHeight] = useState("");
  const [oldWeight, setOldWeight] = useState("");
  const [oldCitizenship, setOldCitizenship] = useState("");
  const [oldReligion, setOldReligion] = useState("");
  const [oldGender, setOldGender] = useState("");
  const [oldMobileNumber, setOldMobileNumber] = useState("");
  const [oldEmailAddress, setOldEmailAddress] = useState("");
  const [oldDeviceNumber, setOldDeviceNumber] = useState("");
  const [oldCompanyId, setOldCompanyId] = useState("");
  const [oldLicense, setOldLicense] = useState("");


  // Address
  const [oldBlkLot, setOldBlkLot] = useState("");
  const [oldProvince, setOldProvince] = useState("");
  const [oldRegion, setOldRegion] = useState("");
  const [oldStreet, setOldStreet] = useState("");
  const [oldBarangay, setOldBarangay] = useState("");
  const [oldCity, setOldCity] = useState("");
  const [oldMunicipality, setOldMunicipality] = useState("");
  const [oldPostalCode, setOldPostalCode] = useState("");
  const [oldYearsOfStay, setOldYearsOfStay] = useState("");

  // Information
  const [oldEffectiveFrom, setOldEffectiveFrom] = useState("");
  const [oldContractFrom, setOldContractFrom] = useState("");
  const [oldContractTo, setOldContractTo] = useState("");
  const [oldLocationId, setOldLocationId] = useState("");
  const [oldDateEmployed, setOldDateEmployed] = useState("");
  const [oldDateRegular, setOldDateRegular] = useState("");
  const [oldDateProbationary, setOldDateProbationary] = useState("");
  const [oldDateProjectBase, setOldDateProjectBase] = useState("");
  const [oldDateContractual, setOldDateContractual] = useState("");
  const [oldEmploymentId, setOldEmploymentId] = useState("");
  const [oldDepartmentId, setOldDepartmentId] = useState("");
  const [oldSectionId, setOldSectionId] = useState("");
  const [oldClassificationId, setOldClassificationId] = useState("");
  const [oldPayTypeId, setOldPayTypeId] = useState("");
  const [oldShiftScheduleId, setOldShiftScheduleId] = useState("");
  const [oldPositionId, setOldPositionId] = useState("");
  const [oldSalaryType, setOldSalaryType] = useState("");
  const [oldmaintenanceSalaryCombinationV2Id, setOldmaintenanceSalaryCombinationV2Id] = useState("");
  const [oldSickLeave, setOldSickLeave] = useState("");
  const [oldVacationLeave, setOldVacationLeave] = useState("");
  const [oldServiceIncentiveLeave, setOldServiceIncentiveLeave] = useState("");
  const [oldEmployeeStatus, setOldEmployeeStatus] = useState("");
  const [oldJobTitleId, setOldJobTitleId] = useState("");
  const [oldEmployeeGroup1Id, setOldEmployeeGroup1Id] = useState("");
  const [oldEmployeeGroup2Id, setOldEmployeeGroup2Id] = useState("");
  const [oldEmployeeTypeId, setOldEmployeeTypeId] = useState("");
  const [oldVesselId, setOldVesselId] = useState("");

  // Accounts
  const [oldSss, setOldsss] = useState("");
  const [oldTin, setOldTin] = useState("");
  const [oldPassport, setOldPassport] = useState("");
  const [oldPhilhealth, setOldPhilhealth] = useState("");
  const [oldPagibig, setOldPagibig] = useState("");

  // Education
  const [oldEmployeeEducationAttainments, setOldEmployeeEducationAttainments] = useState([]);

  // Dependents
  const [oldEmployeeDependents, setOldEmployeeDependents] = useState([]);

  // Emergency Contacts
  const [oldEmployeeEmergencyContacts, setOldEmployeeEmergencyContacts] = useState([]);

  // Family
  const [oldEmployeeFamilyData, setOldEmployeeFamilyData] = useState([]);

  const apiUrl = domain + "/api/Employee";
  const { triggerRefetch } = useRefetchTrigger();


  // New Hooks
  const {
    data: employeeSalaryConfigData,
    loading: employeeSalaryConfigLoading
  } = useEmployeeSalaryConfig({ employeePersonalInformationId, showGeneralMessage });

  const handleUpdate = async (event) => {
    event.preventDefault();

    setLoading(true);

    try {
      let licenseToUse = license; // handle logic at the bottom
      // If employee is not active, remove the license
      if (HR7_IS_CLOUD && !getUnliAccount()
        && employeeStatus.toLowerCase() !== "active"
      ) {
        await removeUserSubscription(licenseToUse);
        licenseToUse = null; // Set license to null
      }


      if ((HR7_IS_CLOUD && !license && !getUnliAccount())) {
        setLoading(false);
        showGeneralMessage("Please fill up all the required fields. Check Personal and Information Tab.", false);
        return; // Exit early if fields are empty
      }

      const toBase64 = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });

      let base64String = "";
      let photoToBeSave = "";

      if (selectedFile) {
        base64String = await toBase64(selectedFile);
        photoToBeSave = base64String.split(',')[1];
      }

      let base64StringSignature = "";
      let photoToBeSaveSignature = "";

      if (signature.length > 0) {
        base64StringSignature = await toBase64(signature[0]);
        photoToBeSaveSignature = base64StringSignature.split(',')[1];
      }

      const updatedSeminars = await Promise.all(
        employeeTrainingSeminars.map(async (element, index) => {
          if (!element) {
            console.warn(`⚠️ Element at index ${index} is null or undefined`);
            return element;
          }

          const updatedElement = { ...element };

          if (element.file instanceof File) {
            try {
              const base64 = await fileToBase64(element.file);
              updatedElement.file = base64;
              updatedElement.fileName = element.file.name || element.fileName || null;
            } catch (err) {
              console.error(`Error converting file for element ${index}:`, err);
            }
          } else {
            updatedElement.file = element.file;
            updatedElement.fileName = element.fileName ?? null;
          }

          return updatedElement;
        })
      );

      setEmployeeTrainingSeminars(updatedSeminars);

      const data = {
        id: viewedData.id,
        employeeId: employeeId,
        lastName: lastName,
        firstName: firstName,
        middleName: middleName,
        extensionName: extensionName,
        fullName: lastName + ", " + firstName,
        nickName: nickName,
        age: age ? age : 0,
        dateOfBirth: dateOfBirth ? dateOfBirth : null,
        placeOfBirth: placeOfBirth,
        civilStatus: civilStatus,
        bloodType: bloodType,
        height: height,
        weight: weight,
        citizenship: citizenship,
        religion: religion,
        gender: gender,
        mobileNumber: mobileNumber,
        emailAddress: emailAddress,
        blkLot: blkLot,
        province: province,
        region: region,
        street: street,
        barangay: barangay,
        city: city,
        municipality: municipality,
        postalCode: postalCode,
        yearsOfStay: yearsOfStay ? yearsOfStay : 0,
        photo: selectedFile ? photoToBeSave : "",
        signature: signature ? photoToBeSaveSignature : "",
        license: licenseToUse,
        deviceNumber: deviceNumber,
        employeeInformation: {
          employeePersonalInformationId: viewedData.id,
          effectiveFrom: effectiveFrom ? effectiveFrom : null,
          contractFrom: contractFrom ? contractFrom : null,
          contractTo: contractTo ? contractTo : null,
          locationId: locationId ? locationId : null,
          dateEmployed: dateEmployed ? dateEmployed : null,
          dateRegular: dateRegular ? dateRegular : null,
          dateProbationary: dateProbationary ? dateProbationary : null,
          dateProjectBase: dateProjectBase ? dateProjectBase : null,
          dateContractual: dateContractual ? dateContractual : null,
          dateResigned: dateResigned ? dateResigned : null,
          employmentId: employmentId ? employmentId : null,
          departmentId: departmentId ? departmentId : null,
          sectionId: sectionId ? sectionId : null,
          classificationId: classificationId ? classificationId : null,
          payTypeId: payTypeId ? payTypeId : null,
          shiftScheduleId: shiftScheduleId ? shiftScheduleId : null,
          positionId: positionId ? positionId : null,
          companyId: companyId ? companyId : null,
          salaryType: salaryType,
          maintenanceSalaryCombinationV2Id: maintenanceSalaryCombinationV2Id ? maintenanceSalaryCombinationV2Id : null,
          jobTitleId: jobTitleId ? jobTitleId : null,
          employeeGroup1Id: employeeGroup1Id ? employeeGroup1Id : null,
          employeeGroup2Id: employeeGroup2Id ? employeeGroup2Id : null,
          plantilyaId: plantilyaId ? plantilyaId : null,
          costCenterId: costCenterId ? costCenterId : null,
          clientId: clientId ? clientId : null,
          employeeTypeId: employeeTypeId ? employeeTypeId : null,
          vesselId: vesselId ? vesselId : null,
          destinationId: destinationId ? destinationId : null,
        },
        employeeReportTo: {
          employeePersonalInformationId: viewedData.id,
          reportToId: null
        },
        employeeAccountInformation: {
          employeePersonalInformationId: viewedData.id,
          sss: sss,
          tin: tin,
          passport: passport,
          philhealth: philhealth,
          pagibig: pagibig,
        },
        employeePassportDetail: {
          employeePersonalInformationId: viewedData.id,
          passportNumber: passport,
          passportIssueDate: passportIssueDate ? passportIssueDate : null,
          passportExpiryDate: passportExpiryDate ? passportExpiryDate : null,
        },
        employeeSeamanBookDetail: {
          employeePersonalInformationId: viewedData.id,
          seamanBookNumber: seamansBookNumber,
          bookIssueDate: seamansBookIssueDate ? seamansBookIssueDate : null,
          bookExpiryDate: seamansBookExpiryDate ? seamansBookExpiryDate : null,
        },
        employeeLicenseInformation: {
          employeePersonalInformationId: viewedData.id,
          licenseCode: licenseCode,
          licenseNumber: licenseNumber,
          description: licenseDescription,
          expirationDate: licenseExpirationDate ? licenseExpirationDate : null,
          isQualified: licenseQualified,
        },
        employeeBankAccounts: employeeBankAccounts,
        employeeEducationAttainments: employeeEducationAttainments,
        employeeTrainingSeminars: updatedSeminars,
        employeeDependents: employeeDependents,
        employeeFamilyData: employeeFamilyData,
        employeeEmergencyContacts: employeeEmergencyContacts,
        employeeLeave: {
          employeePersonalInformationId: viewedData.id,
          totalVacation: vacationLeave,
          totalSick: sickLeave,
          totalServiceIncentive: serviceIncentiveLeave,
          totalSoloParent: soloParentLeave,
          sickRemaining: sickRemaining,
          vacationRemaining: vacationRemaining,
          serviceIncentiveRemaining: serviceIncentiveRemaining,
          soloParentRemaining: soloParentRemaining,
        },
        employeeStatuses: {
          employeePersonalInformationId: viewedData.id,
          status: employeeStatus,
        },
        employeeRestDays: employeeRestDays
      };

      // Create the Users Subscription
      if (HR7_IS_CLOUD && license && !getUnliAccount() && employeeStatus.toLowerCase() === "active") {


        const isLicenseTaken = await checkLicenseIfTaken(license, oldEmployeeId.trim());
        const licenseDetails = await fetchLicenseDetails(license);


        // check if old ID is existing, if it is existing, swap it's id with the new id
        if (!isLicenseTaken && oldEmployeeId && oldEmployeeId !== employeeId) {
          console.log({ employeeId, oldEmployeeId });
          await removeUserSubscription(license);
        }

        if (isLicenseTaken === true) { // insert if the license is not taken
          showGeneralMessage("License has been used.", false);
          console.log("Triggered")
          return;
        }

        await insertUserSubscription(license, employeeId.trim());

      }

      await axios.put(apiUrl + `/${viewedData.id}`, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });


      logDifferences();

      if (leaveTabRef.current) {
        await leaveTabRef.current.save(viewedData.id);
      }

      await fetchData();

      setViewedData(data);
      setEmployeeId(data.employeeId);
      setLastName(data.lastName);
      setFirstName(data.firstName);
      setMiddleName(data.middleName);
      setExtensionName(data.extensionName);
      setNickName(data.nickName);
      setAge(data.age);
      setDateOfBirth(data.dateOfBirth);
      setPlaceOfBirth(data.placeOfBirth);
      setCivilStatus(data.civilStatus);
      setBloodType(data.bloodType);
      setHeight(data.height);
      setWeight(data.weight);
      setCitizenship(data.citizenship);
      setReligion(data.religion);
      setGender(data.gender);
      setMobileNumber(data.mobileNumber);
      setEmailAddress(data.emailAddress);
      setLicense(data.license);
      setDeviceNumber(data.deviceNumber);
      setCompanyId(data.employeeInformation.companyId);
      setBlkLot(data.blkLot);
      setProvince(data.province);
      setRegion(data.region);
      setStreet(data.street);
      setBarangay(data.barangay);
      setCity(data.city);
      setMunicipality(data.municipality);
      setPostalCode(data.postalCode);
      setYearsOfStay(data.yearsOfStay);

      if (data.photo) {
        const binaryData = atob(data.photo);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: 'image/jpeg' }); // Adjust the MIME type as per your data

        const file = new File([blob], 'filename.jpg', { type: 'image/jpeg' }); // Provide a filename and MIME type

        setEmployeePhoto(file);
        setSelectedFile(file);
      }

      let filesToBeSet = [];
      if (data.signature) {
        const binaryData = atob(data.signature);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: 'image/jpeg' }); // Adjust the MIME type as per your data

        const file = new File([blob], 'filename.jpg', { type: 'image/jpeg' }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setSignature(filesToBeSet);

      setEffectiveFrom(data.employeeInformation.effectiveFrom);
      setContractFrom(data.employeeInformation.contractFrom);
      setContractTo(data.employeeInformation.contractTo);
      setLocationId(data.employeeInformation.locationId);
      setDateEmployed(data.employeeInformation.dateEmployed);
      setDateRegular(data.employeeInformation.dateRegular);
      setDateProbationary(data.employeeInformation.dateProbationary);
      setDateProjectBase(data.employeeInformation.dateProjectBase);
      setDateContractual(data.employeeInformation.dateContractual);
      setDateResigned(data.employeeInformation.dateResigned);
      setEmploymentId(data.employeeInformation.employmentId);
      setDepartmentId(data.employeeInformation.departmentId);
      setSectionId(data.employeeInformation.sectionId);
      setClassificationId(data.employeeInformation.classificationId);
      setPayTypeId(data.employeeInformation.payTypeId);
      setShiftScheduleId(data.employeeInformation.shiftScheduleId);
      setPositionId(data.employeeInformation.positionId);
      setSalaryType(data.employeeInformation.salaryType);
      setmaintenanceSalaryCombinationV2Id(data.employeeInformation.maintenanceSalaryCombinationV2Id);
      setJobTitleId(data.employeeInformation.jobTitleId);
      setEmployeeGroup1Id(data.employeeInformation.employeeGroup1Id);
      setEmployeeGroup2Id(data.employeeInformation.employeeGroup2Id);
      setPlantilyaId(data.employeeInformation.plantilyaId);
      setCostCenterId(data.employeeInformation.costCenterId);
      setClientId(data.employeeInformation.clientId);
      setEmployeeTypeId(data.employeeInformation.employeeTypeId);
      setVesselId(data.employeeInformation.vesselId);
      /* setVacationLeave(data.);
      setSickLeave("");
      setServiceIncentiveLeave("");
      setEmployeeStatus(""); */

      // Accounts : Update this 
      setsss(data.employeeAccountInformation.sss);
      setTin(data.employeeAccountInformation.tin);
      setPassport(data.employeeAccountInformation.passport);
      setPhilhealth(data.employeeAccountInformation.philhealth);
      setPagibig(data.employeeAccountInformation.pagibig);

      setEmployeeBankAccounts(data.employeeBankAccounts);

      setVacationLeave((data.employeeLeave && data.employeeLeave.totalVacation) ? data.employeeLeave.totalVacation : 0)
      setSickLeave((data.employeeLeave && data.employeeLeave.totalSick) ? data.employeeLeave.totalSick : 0)
      setServiceIncentiveLeave((data.employeeLeave && data.employeeLeave.totalServiceIncentive) ? data.employeeLeave.totalServiceIncentive : 0)
      setSoloParentLeave((data.employeeLeave && data.employeeLeave.totalSoloParent) ? data.employeeLeave.totalSoloParent : 0)
      setVacationRemaining((data.employeeLeave && data.employeeLeave.vacationRemaining) ? data.employeeLeave.vacationRemaining : 0)
      setSickRemaining((data.employeeLeave && data.employeeLeave.sickRemaining) ? data.employeeLeave.sickRemaining : 0)
      setServiceIncentiveRemaining((data.employeeLeave && data.employeeLeave.setVacationRemaining) ? data.employeeLeave.setVacationRemaining : 0)
      setSoloParentRemaining((data.employeeLeave && data.employeeLeave.soloParentRemaining) ? data.employeeLeave.soloParentRemaining : 0)
      setEmployeeStatus((data.employeeStatuses && data.employeeStatuses.status) ? data.employeeStatuses.status : "")

      setEmployeeEducationAttainments(data.employeeEducationAttainments);
      setEmployeeTrainingSeminars(data.employeeTrainingSeminars);
      setEmployeeDependents(data.employeeDependents);
      setEmployeeEmergencyContacts(data.employeeEmergencyContacts);
      setEmployeeFamilyData(data.employeeFamilyData);
      setIsEditMode(false);
      triggerRefetch();

      showGeneralMessage("Employee updated successfully!", true);
    } catch (error) {
      setLoading(false);
      console.error('There was a problem updating data:', error);
      const errorMessage = error.response?.data?.message || "An error occurred while updating.";
      showGeneralMessage(errorMessage, false);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    onClose();
    setIsOpenOnce(false);
    setSelectedTab(0);
    setIsFirstPage(true);
    setIsLastPage(false);
    setIsEditMode(false);
    setEmployeePersonalInformationId("");
    setEmployeeId("");
    setLastName("");
    setFirstName("");
    setMiddleName("");
    setExtensionName("");
    setNickName("");
    setAge("");
    setDateOfBirth("");
    setPlaceOfBirth("");
    setCivilStatus("");
    setBloodType("");
    setHeight("");
    setWeight("");
    setCitizenship("");
    setReligion("");
    setGender("");
    setMobileNumber("");
    setEmailAddress("");
    setLicense("");
    setDeviceNumber("");
    setCompanyId("");
    setBlkLot("");
    setProvince("");
    setRegion("");
    setStreet("");
    setBarangay("");
    setCity("");
    setMunicipality("");
    setPostalCode("");
    setYearsOfStay("");
    setSelectedFile("");
    setSignature([]);

    // Information Tab
    setEffectiveFrom("");
    setContractFrom("");
    setContractTo("");
    setLocationId("");
    setDateEmployed("");
    setDateRegular("");
    setDateProbationary("");
    setDateProjectBase("");
    setDateContractual("");
    setDateResigned("");
    setEmploymentId("");
    setDepartmentId("");
    setSectionId("");
    setClassificationId("");
    setPayTypeId("");
    setShiftScheduleId("");
    setPositionId("");
    setSalaryType("");
    setmaintenanceSalaryCombinationV2Id("");
    setJobTitleId("");
    setEmployeeGroup1Id("");
    setEmployeeGroup2Id("");
    setPlantilyaId("");
    setCostCenterId("");
    setClientId("");
    setEmployeeTypeId("");
    setVesselId("");
    setDestinationId("");
    setVacationLeave("")
    setSickLeave("")
    setServiceIncentiveLeave("")
    setSoloParentLeave("")
    setVacationRemaining("")
    setSickRemaining("")
    setServiceIncentiveRemaining("")
    setSoloParentRemaining("")
    setEmployeeStatus("")

    setsss("");
    setTin("");
    setPassport("");
    setPhilhealth("");
    setPagibig("");

    setPassport("");
    setPassportIssueDate("");
    setPassportExpiryDate("");
    setSeamansBookNumber("");
    setSeamansBookIssueDate("");
    setSeamansBookExpiryDate("");

    setLicenseCode("");
    setLicenseDescription("");
    setLicenseNumber("");
    setLicenseQualified(false);
    setLicenseExpirationDate("");

    setEmployeeBankAccounts([]);
    setEmployeeEducationAttainments([]);
    setEmployeeTrainingSeminars([]);
    setEmployeeDependents([]);
    setEmployeeEmergencyContacts([]);
    setEmployeeFamilyData([]);
  };

  useEffect(() => {
    if (isOpen && !isOpenOnce) {
      setIsOpenOnce(true);
      setEmployeePersonalInformationId(viewedData.id);
      setEmployeeId(viewedData.employeeId);
      setLastName(viewedData.lastName);
      setFirstName(viewedData.firstName);
      setMiddleName(viewedData.middleName);
      setExtensionName(viewedData.extensionName);
      setNickName(viewedData.nickName);
      setAge(viewedData.age);
      setDateOfBirth(viewedData.dateOfBirth);
      setPlaceOfBirth(viewedData.placeOfBirth);
      setCivilStatus(viewedData.civilStatus);
      setBloodType(viewedData.bloodType);
      setHeight(viewedData.height);
      setWeight(viewedData.weight);
      setCitizenship(viewedData.citizenship);
      setReligion(viewedData.religion);
      setGender(viewedData.gender);
      setMobileNumber(viewedData.mobileNumber);
      setEmailAddress(viewedData.emailAddress);
      setDeviceNumber(viewedData.deviceNumber);
      setLicense(viewedData.license);
      setBlkLot(viewedData.blkLot);
      setProvince(viewedData.province);
      setRegion(viewedData.region);
      setStreet(viewedData.street);
      setBarangay(viewedData.barangay);
      setCity(viewedData.city);
      setMunicipality(viewedData.municipality);
      setPostalCode(viewedData.postalCode);
      setYearsOfStay(viewedData.yearsOfStay);

      if (viewedData.photo) {
        const binaryData = atob(viewedData.photo);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: 'image/jpeg' }); // Adjust the MIME type as per your data

        const file = new File([blob], 'filename.jpg', { type: 'image/jpeg' }); // Provide a filename and MIME type

        setSelectedFile(file);
      }

      let filesToBeSet = [];
      if (viewedData.signature) {
        const binaryData = atob(viewedData.signature);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: 'image/jpeg' }); // Adjust the MIME type as per your data

        const file = new File([blob], 'filename.jpg', { type: 'image/jpeg' }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setSignature(filesToBeSet);

      if (viewedData.employeeInformation) {
        setCompanyId(viewedData.employeeInformation.companyId);
        setEffectiveFrom(viewedData.employeeInformation.effectiveFrom);
        setContractFrom(viewedData.employeeInformation.contractFrom);
        setContractTo(viewedData.employeeInformation.contractTo);
        setLocationId(viewedData.employeeInformation.locationId);
        setDateEmployed(viewedData.employeeInformation.dateEmployed);
        setDateRegular(viewedData.employeeInformation.dateRegular);
        setDateProbationary(viewedData.employeeInformation.dateProbationary);
        setDateProjectBase(viewedData.employeeInformation.dateProjectBase);
        setDateContractual(viewedData.employeeInformation.dateContractual);
        setDateResigned(viewedData.employeeInformation.dateResigned);
        setEmploymentId(viewedData.employeeInformation.employmentId);
        setDepartmentId(viewedData.employeeInformation.departmentId);
        setSectionId(viewedData.employeeInformation.sectionId);
        setClassificationId(viewedData.employeeInformation.classificationId);
        setPayTypeId(viewedData.employeeInformation.payTypeId);
        setShiftScheduleId(viewedData.employeeInformation.shiftScheduleId);
        setPositionId(viewedData.employeeInformation.positionId);
        setSalaryType(viewedData.employeeInformation.salaryType);
        setmaintenanceSalaryCombinationV2Id(viewedData.employeeInformation.maintenanceSalaryCombinationV2Id);
        setJobTitleId(viewedData.employeeInformation.jobTitleId);
        setEmployeeGroup1Id(viewedData.employeeInformation.employeeGroup1Id);
        setEmployeeGroup2Id(viewedData.employeeInformation.employeeGroup2Id);
        setPlantilyaId(viewedData.employeeInformation.plantilyaId);
        setCostCenterId(viewedData.employeeInformation.costCenterId);
        setClientId(viewedData.employeeInformation.clientId);
        setEmployeeTypeId(viewedData.employeeInformation.employeeTypeId);
        setVesselId(viewedData.employeeInformation.vesselId);
        setDestinationId(viewedData.employeeInformation.destinationId);
      } else {
        setCompanyId("");
        setEffectiveFrom("");
        setContractFrom("");
        setContractTo("");
        setLocationId("");
        setDateEmployed("");
        setDateRegular("");
        setDateProbationary("");
        setDateProjectBase("");
        setDateContractual("");
        setEmploymentId("");
        setDepartmentId("");
        setSectionId("");
        setClassificationId("");
        setPayTypeId("");
        setShiftScheduleId("");
        setPositionId("");
        setSalaryType("");
        setmaintenanceSalaryCombinationV2Id("");
        setJobTitleId("");
        setEmployeeGroup1Id("");
        setEmployeeGroup2Id("");
        setPlantilyaId("");
        setCostCenterId("");
        setClientId("");
        setEmployeeTypeId("");
        setVesselId("");
        setDestinationId("");
      }

      if (viewedData.employeeLeave) {
        setSickLeave(viewedData.employeeLeave.totalSick ? viewedData.employeeLeave.totalSick : 0);
        setVacationLeave(viewedData.employeeLeave.totalVacation ? viewedData.employeeLeave.totalVacation : 0);
        setServiceIncentiveLeave(viewedData.employeeLeave.totalServiceIncentive ? viewedData.employeeLeave.totalServiceIncentive : 0);
        setSoloParentLeave(viewedData.employeeLeave.totalSoloParent ? viewedData.employeeLeave.totalSoloParent : 0);

        setSickRemaining(viewedData.employeeLeave.sickRemaining ? viewedData.employeeLeave.sickRemaining : 0);
        setVacationRemaining(viewedData.employeeLeave.vacationRemaining ? viewedData.employeeLeave.vacationRemaining : 0);
        setServiceIncentiveRemaining(viewedData.employeeLeave.serviceIncentiveRemaining ? viewedData.employeeLeave.serviceIncentiveRemaining : 0);
        setSoloParentRemaining(viewedData.employeeLeave.soloParentRemaining ? viewedData.employeeLeave.soloParentRemaining : 0);
      } else {
        setSickLeave(0);
        setVacationLeave(0);
        setServiceIncentiveLeave(0);
        setSoloParentLeave(0);

        setSickRemaining(0);
        setVacationRemaining(0);
        setServiceIncentiveRemaining(0);
        setSoloParentRemaining(0);
      }

      if (viewedData.employeeStatuses) {
        setEmployeeStatus(viewedData.employeeStatuses.status ? viewedData.employeeStatuses.status : "");
      } else {
        setEmployeeStatus("");
      }

      setsss(viewedData.employeeAccountInformation ? viewedData.employeeAccountInformation.sss : null);
      setTin(viewedData.employeeAccountInformation ? viewedData.employeeAccountInformation.tin : null);
      setPassport(viewedData.employeeAccountInformation ? viewedData.employeeAccountInformation.passport : null);
      setPhilhealth(viewedData.employeeAccountInformation ? viewedData.employeeAccountInformation.philhealth : null);
      setPagibig(viewedData.employeeAccountInformation ? viewedData.employeeAccountInformation.pagibig : null);

      // Passport
      setPassport(viewedData.employeePassportDetail?.passportNumber ?? "");
      setPassportIssueDate(viewedData.employeePassportDetail?.passportIssueDate
        ? viewedData.employeePassportDetail.passportIssueDate.split("T")[0] : "");
      setPassportExpiryDate(viewedData.employeePassportDetail?.passportExpiryDate
        ? viewedData.employeePassportDetail.passportExpiryDate.split("T")[0] : "");

      // Seaman Book
      setSeamansBookNumber(viewedData.employeeSeamanBookDetail?.seamanBookNumber ?? "");
      setSeamansBookIssueDate(viewedData.employeeSeamanBookDetail?.bookIssueDate
        ? viewedData.employeeSeamanBookDetail.bookIssueDate.split("T")[0] : "");
      setSeamansBookExpiryDate(viewedData.employeeSeamanBookDetail?.bookExpiryDate
        ? viewedData.employeeSeamanBookDetail.bookExpiryDate.split("T")[0] : "");

      if (viewedData.employeeLicenseInformation) {
        setLicenseCode(viewedData.employeeLicenseInformation.licenseCode ?? "");
        setLicenseDescription(viewedData.employeeLicenseInformation.description ?? "");
        setLicenseNumber(viewedData.employeeLicenseInformation.licenseNumber ?? "");
        setLicenseQualified(viewedData.employeeLicenseInformation.isQualified ?? false);
        setLicenseExpirationDate(viewedData.employeeLicenseInformation.expirationDate
          ? viewedData.employeeLicenseInformation.expirationDate.split("T")[0]
          : "");
      } else {
        setLicenseCode("");
        setLicenseDescription("");
        setLicenseNumber("");
        setLicenseQualified(false);
        setLicenseExpirationDate("");
      }

      setEmployeeBankAccounts(viewedData.employeeBankAccounts);
      setEmployeeEducationAttainments(viewedData.employeeEducationAttainments);
      setEmployeeTrainingSeminars(viewedData.employeeTrainingSeminars);
      setEmployeeDependents(viewedData.employeeDependents);
      setEmployeeEmergencyContacts(viewedData.employeeEmergencyContacts);
      setEmployeeFamilyData(viewedData.employeeFamilyData);
      setEmployeeRestDays(viewedData.employeeRestDays);
    }
  }, [isOpen, viewedData, isOpenOnce]);

  // In your ViewEmployee component

  useEffect(() => {
    if (!isInit) {
      setIsInit(true);
      setOldEmployeeId(viewedData.employeeId);
      setOldLastName(viewedData.lastName);
      setOldFirstName(viewedData.firstName);
      setOldMiddleName(viewedData.middleName);
      setOldExtensionName(viewedData.extensionName);
      setOldNickName(viewedData.nickName);
      setOldAge(viewedData.age);
      setOldDateOfBirth(viewedData.dateOfBirth);
      setOldPlaceOfBirth(viewedData.placeOfBirth);
      setOldCivilStatus(viewedData.civilStatus);
      setOldBloodType(viewedData.bloodType);
      setOldHeight(viewedData.height);
      setOldWeight(viewedData.weight);
      setOldCitizenship(viewedData.citizenship);
      setOldReligion(viewedData.religion);
      setOldGender(viewedData.gender);
      setOldMobileNumber(viewedData.mobileNumber);
      setOldEmailAddress(viewedData.emailAddress);
      setOldDeviceNumber(viewedData.deviceNumber);
      setOldLicense(viewedData.license);
      setOldBlkLot(viewedData.blkLot);
      setOldProvince(viewedData.province);
      setOldRegion(viewedData.region);
      setOldStreet(viewedData.street);
      setOldBarangay(viewedData.barangay);
      setOldCity(viewedData.city);
      setOldMunicipality(viewedData.municipality);
      setOldPostalCode(viewedData.postalCode);
      setOldYearsOfStay(viewedData.yearsOfStay);

      if (viewedData.photo) {
        const binaryData = atob(viewedData.photo);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: 'image/jpeg' }); // Adjust the MIME type as per your data

        const file = new File([blob], 'filename.jpg', { type: 'image/jpeg' }); // Provide a filename and MIME type

        setOldSelectedFile(file);
      }

      if (viewedData.employeeInformation) {
        setOldCompanyId(viewedData.employeeInformation.companyId);
        setOldEffectiveFrom(viewedData.employeeInformation.effectiveFrom);
        setOldContractFrom(viewedData.employeeInformation.contractFrom);
        setOldContractTo(viewedData.employeeInformation.contractTo);
        setOldLocationId(viewedData.employeeInformation.locationId);
        setOldDateEmployed(viewedData.employeeInformation.dateEmployed);
        setOldDateRegular(viewedData.employeeInformation.dateRegular);
        setOldDateProbationary(viewedData.employeeInformation.dateProbationary);
        setOldDateProjectBase(viewedData.employeeInformation.dateProjectBase);
        setOldDateContractual(viewedData.employeeInformation.dateContractual);
        setOldEmploymentId(viewedData.employeeInformation.employmentId);
        setOldDepartmentId(viewedData.employeeInformation.departmentId);
        setOldSectionId(viewedData.employeeInformation.sectionId);
        setOldClassificationId(viewedData.employeeInformation.classificationId);
        setOldPayTypeId(viewedData.employeeInformation.payTypeId);
        setOldShiftScheduleId(viewedData.employeeInformation.shiftScheduleId);
        setOldPositionId(viewedData.employeeInformation.positionId);
        setOldSalaryType(viewedData.employeeInformation.salaryType);
        setOldmaintenanceSalaryCombinationV2Id(viewedData.employeeInformation.maintenanceSalaryCombinationV2Id);
        setOldJobTitleId(viewedData.employeeInformation.jobTitleId);
        setOldEmployeeGroup1Id(viewedData.employeeInformation.employeeGroup1Id);
        setOldEmployeeGroup2Id(viewedData.employeeInformation.employeeGroup2Id);
        setOldEmployeeTypeId(viewedData.employeeInformation.employeeTypeId);
        setOldVesselId(viewedData.employeeInformation.vesselId);
      } else {
        setOldCompanyId("");
        setOldEffectiveFrom("");
        setOldContractFrom("");
        setOldContractTo("");
        setOldLocationId("");
        setOldDateEmployed("");
        setOldDateRegular("");
        setOldDateProbationary("");
        setOldDateProjectBase("");
        setOldDateContractual("");
        setOldEmploymentId("");
        setOldDepartmentId("");
        setOldSectionId("");
        setOldClassificationId("");
        setOldPayTypeId("");
        setOldShiftScheduleId("");
        setOldPositionId("");
        setOldSalaryType("");
        setOldmaintenanceSalaryCombinationV2Id("");
        setOldJobTitleId("");
        setOldEmployeeGroup1Id("");
        setOldEmployeeGroup2Id("");
        setOldEmployeeTypeId("");
        setOldVesselId("");
      }

      if (viewedData.employeeLeave) {
        setOldSickLeave(viewedData.employeeLeave.totalSick ? viewedData.employeeLeave.totalSick : 0);
        setOldVacationLeave(viewedData.employeeLeave.totalVacation ? viewedData.employeeLeave.totalVacation : 0);
        setOldServiceIncentiveLeave(viewedData.employeeLeave.totalServiceIncentive ? viewedData.employeeLeave.totalServiceIncentive : 0);
      } else {
        setOldSickLeave(0);
        setOldVacationLeave(0);
        setOldServiceIncentiveLeave(0);
      }

      if (viewedData.employeeStatuses) {
        setOldEmployeeStatus(viewedData.employeeStatuses.status ? viewedData.employeeStatuses.status : "");
      } else {
        setOldEmployeeStatus("");
      }

      setOldsss(viewedData.employeeAccountInformation ? viewedData.employeeAccountInformation.sss : null);
      setOldTin(viewedData.employeeAccountInformation ? viewedData.employeeAccountInformation.tin : null);
      setOldPassport(viewedData.employeeAccountInformation ? viewedData.employeeAccountInformation.passport : null);
      setOldPhilhealth(viewedData.employeeAccountInformation ? viewedData.employeeAccountInformation.philhealth : null);
      setOldPagibig(viewedData.employeeAccountInformation ? viewedData.employeeAccountInformation.pagibig : null);
      setOldEmployeeEducationAttainments(viewedData.employeeEducationAttainments);
      setOldEmployeeDependents(viewedData.employeeDependents);
      setOldEmployeeEmergencyContacts(viewedData.employeeEmergencyContacts);
      setOldEmployeeFamilyData(viewedData.employeeFamilyData);
    }
  }, [isInit, viewedData]);

  useEffect(() => {
    if (selectedTab > 0) {
      setIsFirstPage(false);
    } else {
      setIsFirstPage(true);
    }

    if (selectedTab === 9) {
      setIsLastPage(true);
    } else {
      setIsLastPage(false);
    }
  }, [selectedTab]);

  useEffect(() => {
    if (showSuccess) {
      const timeoutId = setTimeout(() => {
        setShowSuccess(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [showSuccess]); // This useEffect will run whenever selectedTab changes

  const setButtonId = (name) => {
    if (name === "previous-button") {
      if (isFirstPage) {
        return "previous-button"
      } else {
        return "active-previous-button"
      }
    } else if (name === "next-button") {
      if (isLastPage) {
        return "next-button"
      } else {
        return "active-next-button"
      }
    }
  }

  const logDifferences = async () => {
    const fieldsToCompare = [
      { oldValue: oldEmployeeId, newValue: employeeId, field: `${employeeId} Employee ID` },
      { oldValue: oldSelectedFile, newValue: selectedFile, field: `${employeeId} Photo` },
      { oldValue: oldLastName, newValue: lastName, field: `${employeeId} Last Name` },
      { oldValue: oldFirstName, newValue: firstName, field: `${employeeId} First Name` },
      { oldValue: oldMiddleName, newValue: middleName, field: `${employeeId} Middle Name` },
      { oldValue: oldExtensionName, newValue: extensionName, field: `${employeeId} Extension Name` },
      { oldValue: oldNickName, newValue: nickName, field: `${employeeId} Nick Name` },
      { oldValue: oldAge, newValue: age, field: `${employeeId} Age` },
      { oldValue: oldDateOfBirth, newValue: dateOfBirth, field: `${employeeId} Date of Birth` },
      { oldValue: oldPlaceOfBirth, newValue: placeOfBirth, field: `${employeeId} Place of Birth` },
      { oldValue: oldCivilStatus, newValue: civilStatus, field: `${employeeId} Civil Status` },
      { oldValue: oldBloodType, newValue: bloodType, field: `${employeeId} Blood Type` },
      { oldValue: oldHeight, newValue: height, field: `${employeeId} Height` },
      { oldValue: oldWeight, newValue: weight, field: `${employeeId} Weight` },
      { oldValue: oldLicense, newValue: license, field: `${employeeId} License` },
      { oldValue: oldCitizenship, newValue: citizenship, field: `${employeeId} Citizenship` },
      { oldValue: oldReligion, newValue: religion, field: `${employeeId} Religion` },
      { oldValue: oldGender, newValue: gender, field: `${employeeId} Gender` },
      { oldValue: oldMobileNumber, newValue: mobileNumber, field: `${employeeId} Mobile Number` },
      { oldValue: oldEmailAddress, newValue: emailAddress, field: `${employeeId} Email Address` },
      { oldValue: oldDeviceNumber, newValue: deviceNumber, field: `${employeeId} Device Number` },
      { oldValue: oldCompanyId, newValue: companyId, field: `${employeeId} Company ID` },
      { oldValue: oldBlkLot, newValue: blkLot, field: `${employeeId} Blk Lot` },
      { oldValue: oldProvince, newValue: province, field: `${employeeId} Province` },
      { oldValue: oldRegion, newValue: region, field: `${employeeId} Region` },
      { oldValue: oldStreet, newValue: street, field: `${employeeId} Street` },
      { oldValue: oldBarangay, newValue: barangay, field: `${employeeId} Barangay` },
      { oldValue: oldCity, newValue: city, field: `${employeeId} City` },
      { oldValue: oldMunicipality, newValue: municipality, field: `${employeeId} Municipality Code` },
      { oldValue: oldPostalCode, newValue: postalCode, field: `${employeeId} Postal Code` },
      { oldValue: oldYearsOfStay, newValue: yearsOfStay, field: `${employeeId} Years of Stay` },
      { oldValue: oldEffectiveFrom, newValue: effectiveFrom, field: `${employeeId} Effective Date` },
      { oldValue: oldContractFrom, newValue: contractFrom, field: `${employeeId} Contract From` },
      { oldValue: oldContractTo, newValue: contractTo, field: `${employeeId} Contract To` },
      { oldValue: oldLocationId, newValue: locationId, field: `${employeeId} Location ID` },
      { oldValue: oldDateEmployed, newValue: dateEmployed, field: `${employeeId} Date Employed` },
      { oldValue: oldDateRegular, newValue: dateRegular, field: `${employeeId} Date Regular` },
      { oldValue: oldDateProbationary, newValue: dateProbationary, field: `${employeeId} Date Probationary` },
      { oldValue: oldDateProjectBase, newValue: dateProjectBase, field: `${employeeId} Date Project Base` },
      { oldValue: oldDateContractual, newValue: dateContractual, field: `${employeeId} Date Contractual` },
      { oldValue: oldEmploymentId, newValue: employmentId, field: `${employeeId} Employment ID` },
      { oldValue: oldDepartmentId, newValue: departmentId, field: `${employeeId} Department ID` },
      { oldValue: oldSectionId, newValue: sectionId, field: `${employeeId} Section ID` },
      { oldValue: oldClassificationId, newValue: classificationId, field: `${employeeId} Classification ID` },
      { oldValue: oldPayTypeId, newValue: payTypeId, field: `${employeeId} Pay Type ID` },
      { oldValue: oldShiftScheduleId, newValue: shiftScheduleId, field: `${employeeId} Shift Schedule ID` },
      { oldValue: oldPositionId, newValue: positionId, field: `${employeeId} Position ID` },
      { oldValue: oldSalaryType, newValue: salaryType, field: `${employeeId} Salary Type` },
      { oldValue: oldmaintenanceSalaryCombinationV2Id, newValue: maintenanceSalaryCombinationV2Id, field: `${employeeId} Maintenance Salary Combination` },
      { oldValue: oldJobTitleId, newValue: jobTitleId, field: `${employeeId} Job Title` },
      { oldValue: oldEmployeeGroup1Id, newValue: employeeGroup1Id, field: `${employeeId} Employee Group 1` },
      { oldValue: oldEmployeeGroup2Id, newValue: employeeGroup2Id, field: `${employeeId} Employee Group 2` },
      { oldValue: oldEmployeeTypeId, newValue: employeeTypeId, field: `${employeeId} Employee Type` },
      { oldValue: oldVesselId, newValue: vesselId, field: `${employeeId} Vessel` },
      { oldValue: oldSickLeave, newValue: sickLeave, field: `${employeeId} Sick Leave` },
      { oldValue: oldVacationLeave, newValue: vacationLeave, field: `${employeeId} Vacation Leave` },
      { oldValue: oldServiceIncentiveLeave, newValue: serviceIncentiveLeave, field: `${employeeId} Service Incentive Leave` },
      { oldValue: oldEmployeeStatus, newValue: employeeStatus, field: `${employeeId} Employee Status` },
      { oldValue: oldSss, newValue: sss, field: `${employeeId} SSS` },
      { oldValue: oldTin, newValue: tin, field: `${employeeId} TIN` },
      { oldValue: oldPassport, newValue: passport, field: `${employeeId} Passport` },
      { oldValue: oldPhilhealth, newValue: philhealth, field: `${employeeId} PhilHealth` },
      { oldValue: oldPagibig, newValue: pagibig, field: `${employeeId} PagIbig` },
      { oldValue: oldEmployeeEducationAttainments, newValue: employeeEducationAttainments, field: `${employeeId} Employee Education` },
      { oldValue: oldEmployeeDependents, newValue: employeeDependents, field: `${employeeId} Employee Dependents` },
      { oldValue: oldEmployeeEmergencyContacts, newValue: employeeEmergencyContacts, field: `${employeeId} Emergency Contacts` },
      { oldValue: oldEmployeeFamilyData, newValue: employeeFamilyData, field: `${employeeId} Family Data` },
    ];

    for (const { oldValue, newValue, field } of fieldsToCompare) {
      const difference = getDifference(oldValue, newValue, field);
      if (difference.isDifferent) {
        await SetAuditTrail({
          setupArea: `Employee List`,
          actionTaken: `update`,
          field: field, // Set the correct field name
          newValue: difference.newValue ? `${difference.newValue}` : `-`, // Set the actual new value or fallback
          oldValue: difference.oldValue ? `${difference.oldValue}` : `-`, // Set the actual old value or fallback
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
    }
  };
  const getDifference = (oldValue, newValue, field) => {
    let difference = {
      isDifferent: false,
      field: "",
      oldValue: "",
      newValue: ""
    };

    // Check if either oldValue or newValue is an object
    const isObject = (value) => typeof value === 'object' && value !== null;

    const formatValue = (value) => {
      if (isObject(value)) {
        return "-"; // If value is an object, return "-"
      }
      return value; // Return the value itself if it's not an object
    };

    if (oldValue !== newValue) {
      difference = {
        isDifferent: true,
        field: field,
        oldValue: formatValue(oldValue),
        newValue: formatValue(newValue)
      };
    }

    return difference;
  };

  useEffect(() => {
    if (!dateOfBirth) {
      setAge(0);
      return;
    }

    const birthDate = new Date(dateOfBirth);
    const today = new Date();

    let calculatedAge = today.getFullYear() - birthDate.getFullYear();

    const hasHadBirthdayThisYear =
      today.getMonth() > birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() &&
        today.getDate() >= birthDate.getDate());

    if (!hasHadBirthdayThisYear) {
      calculatedAge--;
    }

    setAge(calculatedAge);
  }, [setAge, dateOfBirth]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal view-employee">
            <div className="popUp-header view-employee-header row">
              <div className='popUp-title'><h3 style={{ color: "#668fca" }}>View Employee</h3></div>
              <div className='popUp-close'><CloseIcon onClick={() => handleClose()} /></div>
            </div>
            <div>
              <div className="educations-tab-top"
                style={{
                  display: "flex",
                  justifyContent: "start",
                  padding: "0 20px",
                  visibility: isEditMode ? "hidden" : "visible"
                }}>
                {CreateButton("addEmployee-education-add", "add row", () => setIsEditMode(true), "EDIT INFO", "")}
              </div>
              <div className="employeesTab-body">
                <div className='employeesTab-tab view-emp'>
                  <div style={{ border: "1px solid #00000026", borderRadius: "5px" }}>
                    <Tabs id="employees-tabs-element" selectedIndex={selectedTab} onSelect={index => setSelectedTab(index)}>
                      <TabList>
                        <Tab><b>PERSONAL</b></Tab>
                        <Tab><b>ADDRESS</b></Tab>
                        <Tab><b>INFORMATION</b></Tab>
                        <Tab><b>ACCOUNTS</b></Tab>
                        <Tab><b>EDUCATIONS</b></Tab>
                        <Tab><b>DEPENDENTS</b></Tab>
                        <Tab><b>EMERGENCY</b></Tab>
                        <Tab><b>FAMILY</b></Tab>
                        <Tab><b>BENEFITS</b></Tab>
                        <Tab><b>REQUIREMENTS</b></Tab>
                        <Tab><b>GENERATE ID</b></Tab>
                        <Tab><b>MEMO</b></Tab>
                        {ALLOW_LEAVE_CREDITS_MODULE && (
                          <Tab><b>LEAVE CREDITS</b></Tab>
                        )}
                        <Tab><b>SALARY</b></Tab>
                      </TabList>
                      <div className="employeesTab-tabPanel" style={{ overflow: "auto" }}>
                        <TabPanel>
                          <PersonalTab
                            employeeId={employeeId}
                            selectedFile={selectedFile}
                            setSelectedFile={setSelectedFile}
                            lastName={lastName}
                            firstName={firstName}
                            middleName={middleName}
                            extensionName={extensionName}
                            nickName={nickName}
                            age={age}
                            dateOfBirth={dateOfBirth}
                            placeOfBirth={placeOfBirth}
                            civilStatus={civilStatus}
                            bloodType={bloodType}
                            height={height}
                            weight={weight}
                            citizenship={citizenship}
                            religion={religion}
                            gender={gender}
                            mobileNumber={mobileNumber}
                            emailAddress={emailAddress}
                            deviceNumber={deviceNumber}
                            companyId={companyId}
                            license={license}
                            setEmployeeId={setEmployeeId}
                            setLastName={setLastName}
                            setFirstName={setFirstName}
                            setMiddleName={setMiddleName}
                            setExtensionName={setExtensionName}
                            setNickName={setNickName}
                            setAge={setAge}
                            setDateOfBirth={setDateOfBirth}
                            setPlaceOfBirth={setPlaceOfBirth}
                            setCivilStatus={setCivilStatus}
                            setBloodType={setBloodType}
                            setHeight={setHeight}
                            setWeight={setWeight}
                            setCitizenship={setCitizenship}
                            setReligion={setReligion}
                            setGender={setGender}
                            setMobileNumber={setMobileNumber}
                            setEmailAddress={setEmailAddress}
                            setDeviceNumber={setDeviceNumber}
                            setCompanyId={setCompanyId}
                            setLicense={setLicense}


                            signature={signature} setSignature={setSignature}

                            employeeStatus={employeeStatus}

                            isEditMode={isEditMode}
                          />
                        </TabPanel>

                        <TabPanel>
                          {FEATURES.USE_NEW_ADDRESS_API ?
                            <AddressTabWithAPI
                              blkLot={blkLot}
                              province={province}
                              region={region}
                              street={street}
                              barangay={barangay}
                              city={city}
                              municipality={municipality}
                              postalCode={postalCode}
                              yearsOfStay={yearsOfStay}
                              setBlkLot={setBlkLot}
                              setProvince={setProvince}
                              setRegion={setRegion}
                              setStreet={setStreet}
                              setBarangay={setBarangay}
                              setCity={setCity}
                              setMunicipality={setMunicipality}
                              setPostalCode={setPostalCode}
                              setYearsOfStay={setYearsOfStay}
                              dateEmployed={dateEmployed}
                              isEditMode={isEditMode}
                            />
                            :
                            <AddressTab
                              blkLot={blkLot}
                              province={province}
                              region={region}
                              street={street}
                              barangay={barangay}
                              city={city}
                              municipality={municipality}
                              postalCode={postalCode}
                              yearsOfStay={yearsOfStay}
                              setBlkLot={setBlkLot}
                              setProvince={setProvince}
                              setRegion={setRegion}
                              setStreet={setStreet}
                              setBarangay={setBarangay}
                              setCity={setCity}
                              setMunicipality={setMunicipality}
                              setPostalCode={setPostalCode}
                              setYearsOfStay={setYearsOfStay}
                              dateEmployed={dateEmployed}
                              isEditMode={isEditMode}
                            />
                          }
                        </TabPanel>

                        <TabPanel>
                          <InformationTab
                            effectiveFrom={effectiveFrom}
                            contractFrom={contractFrom}
                            contractTo={contractTo}
                            locationId={locationId}
                            dateEmployed={dateEmployed}
                            dateRegular={dateRegular}
                            dateProbationary={dateProbationary}
                            dateProjectBase={dateProjectBase}
                            dateContractual={dateContractual}
                            dateResigned={dateResigned}
                            employmentId={employmentId}
                            departmentId={departmentId}
                            sectionId={sectionId}
                            classificationId={classificationId}
                            payTypeId={payTypeId}
                            shiftScheduleId={shiftScheduleId}
                            positionId={positionId}
                            salaryType={salaryType}
                            maintenanceSalaryCombinationV2Id={maintenanceSalaryCombinationV2Id}
                            setEffectiveFrom={setEffectiveFrom}
                            setContractFrom={setContractFrom}
                            setContractTo={setContractTo}
                            setLocationId={setLocationId}
                            setDateEmployed={setDateEmployed}
                            setDateRegular={setDateRegular}
                            setDateProbationary={setDateProbationary}
                            setDateProjectBase={setDateProjectBase}
                            setDateContractual={setDateContractual}
                            setDateResigned={setDateResigned}
                            setEmploymentId={setEmploymentId}
                            setDepartmentId={setDepartmentId}
                            setSectionId={setSectionId}
                            setClassificationId={setClassificationId}
                            setPayTypeId={setPayTypeId}
                            setShiftScheduleId={setShiftScheduleId}
                            setPositionId={setPositionId}
                            setSalaryType={setSalaryType}
                            setmaintenanceSalaryCombinationV2Id={setmaintenanceSalaryCombinationV2Id}
                            sickLeave={sickLeave}
                            setSickLeave={setSickLeave}
                            vacationLeave={vacationLeave}
                            setVacationLeave={setVacationLeave}
                            employeeStatus={employeeStatus}
                            setEmployeeStatus={setEmployeeStatus}
                            serviceIncentiveLeave={serviceIncentiveLeave}
                            setServiceIncentiveLeave={setServiceIncentiveLeave}
                            soloParentLeave={soloParentLeave}
                            setSoloParentLeave={setSoloParentLeave}

                            sickRemaining={sickRemaining}
                            setSickRemaining={setSickRemaining}
                            vacationRemaining={vacationRemaining}
                            setVacationRemaining={setVacationRemaining}
                            serviceIncentiveRemaining={serviceIncentiveRemaining}
                            setServiceIncentiveRemaining={setServiceIncentiveRemaining}
                            soloParentRemaining={soloParentRemaining}
                            setSoloParentRemaining={setSoloParentRemaining}
                            isEditMode={isEditMode}

                            jobTitleId={jobTitleId} setJobTitleId={setJobTitleId}
                            employeeGroup1Id={employeeGroup1Id} setEmployeeGroup1Id={setEmployeeGroup1Id}
                            employeeGroup2Id={employeeGroup2Id} setEmployeeGroup2Id={setEmployeeGroup2Id}
                            plantilyaId={plantilyaId}
                            setPlantilyaId={setPlantilyaId}
                            costCenterId={costCenterId}
                            setCostCenterId={setCostCenterId}
                            clientId={clientId}
                            setClientId={setClientId}
                            employeeTypeId={employeeTypeId}
                            setEmployeeTypeId={setEmployeeTypeId}
                            vesselId={vesselId}
                            setVesselId={setVesselId}
                            destinationId={destinationId}
                            setDestinationId={setDestinationId}

                            // Value only
                            assignedToFullName={viewedData.employeeInformation?.assignedToFullName}
                            employeeSalaryConfigData={employeeSalaryConfigData}

                            disableEmployeeTransactionFields={FEATURES.ALLOW_EMPLOYEE_TRANSACTION_MODULE}
                            employeeRestDays={employeeRestDays} setEmployeeRestDays={setEmployeeRestDays}
                          />
                        </TabPanel>

                        <TabPanel>
                          <AccountsTab
                            // Government
                            sss={sss}
                            tin={tin}
                            philhealth={philhealth}
                            pagibig={pagibig}
                            setsss={setsss}
                            setTin={setTin}
                            setPhilhealth={setPhilhealth}
                            setPagibig={setPagibig}

                            // Passport & Seaman
                            passport={passport}
                            setPassport={setPassport}
                            passportIssueDate={passportIssueDate}
                            setPassportIssueDate={setPassportIssueDate}
                            passportExpiryDate={passportExpiryDate}
                            setPassportExpiryDate={setPassportExpiryDate}
                            seamansBookNumber={seamansBookNumber}
                            setSeamansBookNumber={setSeamansBookNumber}
                            seamansBookIssueDate={seamansBookIssueDate}
                            setSeamansBookIssueDate={setSeamansBookIssueDate}
                            seamansBookExpiryDate={seamansBookExpiryDate}
                            setSeamansBookExpiryDate={setSeamansBookExpiryDate}


                            // License Info
                            licenseCode={licenseCode}
                            setLicenseCode={setLicenseCode}
                            licenseDescription={licenseDescription}
                            setLicenseDescription={setLicenseDescription}
                            licenseNumber={licenseNumber}
                            setLicenseNumber={setLicenseNumber}
                            licenseQualified={licenseQualified}
                            setLicenseQualified={setLicenseQualified}
                            licenseExpirationDate={licenseExpirationDate}
                            setLicenseExpirationDate={setLicenseExpirationDate}

                            // Employee Banks Info
                            employeeBankAccounts={employeeBankAccounts}
                            setEmployeeBankAccounts={setEmployeeBankAccounts}

                            isEditMode={isEditMode}
                          />
                        </TabPanel>

                        <TabPanel>
                          <Tabs id="educations-tabs-element2" selectedIndex={selectedEducationTab} onSelect={index => setSelectedEducationTab(index)}>
                            <TabList>
                              <Tab><b>EDUCATIONS</b></Tab>
                              <Tab><b>TRAININGS & SEMINARS</b></Tab>
                            </TabList>
                            <TabPanel>
                              <EducationsTab employeePersonalInformationId={employeePersonalInformationId}
                                employeeEducationAttainments={employeeEducationAttainments}
                                setEmployeeEducationAttainments={setEmployeeEducationAttainments}
                                isEditMode={isEditMode}
                              />
                            </TabPanel>
                            <TabPanel>
                              <TrainingsAndSeminarsTab employeePersonalInformationId={employeePersonalInformationId}
                                employeeTrainingSeminars={employeeTrainingSeminars}
                                setEmployeeTrainingSeminars={setEmployeeTrainingSeminars}
                                isEditMode={isEditMode}
                              />
                            </TabPanel>
                          </Tabs>
                        </TabPanel>

                        <TabPanel>
                          <DependentsTab employeeId={employeeId}
                            employeeDependents={employeeDependents}
                            setEmployeeDependents={setEmployeeDependents}
                            isEditMode={isEditMode}
                          />
                        </TabPanel>

                        <TabPanel>
                          <EmergencyTab employeeId={employeeId}
                            employeeEmergencyContacts={employeeEmergencyContacts}
                            setEmployeeEmergencyContacts={setEmployeeEmergencyContacts}
                            isEditMode={isEditMode}
                          />
                        </TabPanel>

                        <TabPanel>
                          <FamilyTab employeeId={employeeId}
                            employeeFamilyData={employeeFamilyData}
                            setEmployeeFamilyData={setEmployeeFamilyData}
                            isEditMode={isEditMode}
                          />
                        </TabPanel>

                        <TabPanel>
                          <BenefitsTab
                            viewedData={viewedData}
                            isEditMode={isEditMode}
                          />
                        </TabPanel>

                        <TabPanel>
                          <RequirementsTab
                            viewedData={viewedData}
                            isEditMode={isEditMode}
                          />
                        </TabPanel>

                        <TabPanel>
                          <GenerateIdTab viewedData={viewedData} />
                        </TabPanel>

                        <TabPanel>
                          <MemoTab
                            viewedData={viewedData}
                            isEditMode={isEditMode}
                          />
                        </TabPanel>

                        {ALLOW_LEAVE_CREDITS_MODULE && (
                          <TabPanel>
                            <LeaveCreditsTab
                              ref={leaveTabRef}
                              employeePersonalInformationId={viewedData?.id}
                              showGeneralMessage={showGeneralMessage}
                              isEditMode={isEditMode}
                            />
                          </TabPanel>
                        )}

                        <TabPanel>
                          <EmployeeSalaryTab
                            data={employeeSalaryConfigData}
                            loading={employeeSalaryConfigLoading}
                            isEditMode={false}
                          />
                        </TabPanel>

                      </div>
                    </Tabs>
                  </div>

                  <div className="tab-footer">
                    <div className="buttons row" style={{ justifyContent: "space-between" }}>
                      <button id={setButtonId("previous-button")}
                        className="previous row"
                        onClick={() => setSelectedTab(Previous(selectedTab))}><NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
                      </button>
                      <button id={setButtonId("next-button")}
                        className="next row"
                        onClick={() => setSelectedTab(Next(selectedTab))}> NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                      </button>
                    </div>
                  </div>

                  <div className="lowerpart">
                    <div style={{ display: isEditMode ? "flex" : "none", justifyContent: "center", padding: "20px 0" }}>
                      <button className="submit"
                        onClick={(event) => handleUpdate(event)}> SUBMIT
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <GeneralMessage
        form={showMessage}   // from hook
        message={message}     // from hook
        isSuccess={isSuccess} // from hook
      />
      <LoadingSpinner loading={loading} />
    </>
  )
}